import { render, staticRenderFns } from "./AumentoGeneral.vue?vue&type=template&id=b1b5220a&scoped=true&"
import script from "./AumentoGeneral.vue?vue&type=script&lang=js&"
export * from "./AumentoGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b5220a",
  null
  
)

export default component.exports